import { useDispatch, useSelector } from "react-redux";
import { fromJS } from "immutable";
import BillingAction from "../../actions/BillingAction";

const useUpgradePlan = () => {
  const dispatch = useDispatch();

  const userLimit =
    useSelector((state: any) => state.billingReducer.get("userLimit")) || fromJS({});

  const invalidMaxPipelines = (currentPipelineCount: number) => {
    const maxPipelines = userLimit.getIn(["entitlements", "maxPipelines"]) || 0;
    if (currentPipelineCount >= maxPipelines) {
      dispatch(BillingAction.showUpgradePlanDialog({ maxPipelines: maxPipelines }));
      return true;
    }
    return false;
  };

  const invalidMaxUsersPerTenant = (currentUserCount: number) => {
    const maxUsersPerTenant = userLimit.getIn(["entitlements", "maxUsersPerTenant"]) || 0;
    if (currentUserCount >= maxUsersPerTenant) {
      dispatch(
        BillingAction.showUpgradePlanDialog({
          maxUsersPerTenant: maxUsersPerTenant,
        })
      );
      return true;
    }
    return false;
  };

  const invalidFeature = (feature: string) => {
    const checkFeature = userLimit.getIn(["entitlements", "featuresEnabled", feature]) || false;
    if (!checkFeature) {
      dispatch(BillingAction.showUpgradePlanDialog({ featuresEnabled: feature }));
      return true;
    }
    return false;
  };

  const invalidIntegration = (app: string) => {
    const integrationsEnabled = userLimit.getIn(["entitlements", "integrationsEnabled"]);
    let checkIntegration = true;
    switch (app) {
      case "facebook":
        checkIntegration = integrationsEnabled.get("facebook") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "facebook",
            })
          );
        }
        break;
      case "threads":
        checkIntegration = integrationsEnabled.get("threads") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "threads",
            })
          );
        }
        break;
      case "instagram":
        checkIntegration = integrationsEnabled.get("instagram") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "instagram",
            })
          );
        }
        break;
      case "twitter":
        checkIntegration = integrationsEnabled.get("twitter") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "twitter",
            })
          );
        }
        break;
      case "linkedin":
        checkIntegration = integrationsEnabled.get("linkedIn") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "linkedIn",
            })
          );
        }
        break;
      case "google":
        checkIntegration = integrationsEnabled.get("googleWorkspace") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "googleWorkspace",
            })
          );
        }
        break;
      case "slack":
        checkIntegration = integrationsEnabled.get("slack") || false;
        if (!checkIntegration) {
          dispatch(
            BillingAction.showUpgradePlanDialog({
              integrationsEnabled: "slack",
            })
          );
        }
        break;
      case "canva":
        // Canva is available on all plans; connection is not billing-gated.
        checkIntegration = true;
        break;
      default:
        checkIntegration = true;
        break;
    }
    return !checkIntegration;
  };

  return {
    invalidMaxPipelines,
    invalidMaxUsersPerTenant,
    invalidFeature,
    invalidIntegration,
  };
};

export default useUpgradePlan;
